import { generateLink } from './generate-link';

export function removeNonNumericCharacters(inputString: string): string {
  if (!inputString) {
    return '';
  }

  return inputString.replace(/[\s()-]/g, '');
}

export function generateWhatsappLink(
  phone: string,
  text: string = 'Oi, estava no Agendamento Online da Medprev e preciso de ajuda.',
) {
  const link = generateLink({
    url: 'https://api.whatsapp.com/send',
    params: [
      {
        key: 'phone',
        value: `55${removeNonNumericCharacters(phone)}`,
      },
      {
        key: 'text',
        value: `${text}`,
      },
    ],
  });
  return link;
}

export const convertHTMLToWhatsAppFormat = (html: string): string => {
  if (!html) {
    return '';
  }

  const tagMap: { [key: string]: string } = {
    p: '\n',
    strong: '*',
    em: '_',
    u: '~',
    li: '\n',
  };

  const regexRemoveSpaces = /\s<[^>]*>/g;
  const formattedHtml = html.replace(regexRemoveSpaces, (match) => {
    return `${match.trim()} `;
  });

  const regexReplaceTags = /<\/?(\w+)[^>]*>/g;
  const whatsappText = formattedHtml.replace(regexReplaceTags, (_match, tag) => {
    const whatsappTag = tagMap[tag.toLowerCase()] || '';
    return whatsappTag;
  });

  return whatsappText;
};
